import React, { ReactNode } from 'react'
import Form from 'antd/lib/form'
import ColorPicker from 'antd/lib/color-picker'
import styles from './index.scss'

interface IProps {
    name: string
    label?: string
    required?: boolean
    requiredMsg?: string
    rules?: any
    suffix?: ReactNode
    allowClear?: boolean
}
const ColorField = (props: IProps) => {
    const {
        name,
        // label,
        required = false,
        requiredMsg = '',
        rules = [],
        allowClear = true
    } = props

    return (
        <div className={styles.container}>
            <Form.Item
                name={name}
                rules={[
                    {
                        required: required,
                        message: requiredMsg || `Please enter your ${name}`
                    },
                    ...rules
                ]}
                hasFeedback
                getValueFromEvent={color => color.toHex()}
            >
                <ColorPicker size="large" showText arrow allowClear={allowClear} />
            </Form.Item>
        </div>
    )
}

export default ColorField
